<template>
  <div class="jeSouhaitePage-container col-sm-12">
    <div class="jeSouhaitePage">
      <div
        v-if="submitted && erreurJeSouhaite != ''"
        class="alert alert-danger text-left global-errors"
      >
        <p>
          {{ erreurJeSouhaite }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>

      <p class="je-souhaite-text">
        {{ "jeSouhaite_text_offre" | translate(locale) }}
      </p>
      <div class="card-group-offre">
        <je-souhaite-offre
          v-if="listeTypesPratique && listeTypesPratique.includes('C')"
          offre-id="C"
          offre-titre="COMPÉTITION"
          offre-text="Cette offre vous ouvre l'accès à l’ensemble des pratiques proposées par votre club, ainsi qu’aux tournois de la SuperLeague 3x3. Elle vous permet également de demander une autorisation pour jouer en compétition ou pratiquer une autre forme de basket dans un autre club."
          offre-img="competition.png"
          :offre-liste="listeOffreC"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
        <je-souhaite-offre
          v-if="listeTypesPratique && listeTypesPratique.includes('L')"
          offre-id="L"
          offre-titre="LOISIR"
          offre-text="Cette offre vous permet d’accéder exclusivement au championnat Loisir proposé par votre club, ainsi qu’aux tournois OpenStart de la SuperLeague 3x3."
          offre-img="loisir.png"
          :offre-liste="listeOffreL"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
        <je-souhaite-offre
          v-if="listeTypesPratique && listeTypesPratique.includes('E')"
          offre-id="ETS"
          offre-titre="ENTREPRISE"
          offre-text="Cette offre vous permet d’accéder exclusivement au championnat Entreprise proposé par votre club, ainsi qu’aux tournois OpenStart de la SuperLeague 3x3."
          offre-img="entreprise.png"
          :offre-liste="listeOffreE"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
        <je-souhaite-offre
          v-if="listeTypesPratique && listeTypesPratique.includes('VS')"
          offre-id="VS"
          offre-titre="VxE - BASKET SANTÉ"
          offre-text="Cette offre vous permet d'accéder exclusivement à la pratique Vivre Ensemble - Basket Santé"
          offre-img="vxe.png"
          :offre-liste="listeOffreVS"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
        <je-souhaite-offre
          v-if="listeTypesPratique && listeTypesPratique.includes('VT')"
          offre-id="VT"
          offre-titre="VxE - BASKETONIK"
          offre-text="Cette offre vous permet d'accéder exclusivement à la pratique Vivre Ensemble - BaskeTonik"
          offre-img="vxe.png"
          :offre-liste="listeOffreVT"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
        <je-souhaite-offre
          v-if="listeTypesPratique && listeTypesPratique.includes('VI')"
          offre-id="VI"
          offre-titre="VxE - BASKET INCLUSIF"
          offre-text="Cette offre vous permet d'accéder exclusivement à la pratique Vivre Ensemble - Basket Inclusif"
          offre-img="vxe.png"
          :offre-liste="listeOffreVI"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
        <je-souhaite-offre
          v-if="listeTypesPratique && listeTypesPratique.includes('M')"
          offre-id="M"
          offre-titre="MICRO BASKET"
          offre-text="Cette offre vous permet d'accéder exclusivement à la pratique du Micro Basket entre 2 et 4 ans"
          offre-img="MB.png"
          :offre-liste="listeOffreM"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
        <je-souhaite-offre
          offre-id="NONE"
          offre-titre=""
          offre-text="Vous ne souhaitez pas pratiquer le basket au sein de votre club."
          offre-img="forbidden_big.png"
          :active-offre="activeOffre"
          @onUpdateOffre="updateActiveOffre"
        ></je-souhaite-offre>
      </div>

      <p
        v-if="activeOffre != ''"
        class="je-souhaite-text mt-5"
        id="partie-fonctions"
      >
        {{ "jeSouhaite_text_fonction" | translate(locale) }}
      </p>

      <div v-if="activeOffre != ''" class="card-group-fonction">
        <je-souhaite-fonction
          v-if="activeOffre != 'NONE'"
          fonction-id="NO_FONCTION"
          fonction-titre="Ne souhaite pas exercer de fonction"
          fonction-img="forbidden_small.png"
          :is-fonction-disabled="isFonctionDisabled('NO_FONCTION')"
          :is-fonction-checked="isFonctionChecked('NO_FONCTION')"
          :active-fonction-list="activeFonctionList"
          @onUpdateFonctionList="updateActiveFonctionList"
        ></je-souhaite-fonction>
        <je-souhaite-fonction
          v-if="activeOffre != 'M'"
          fonction-id="A"
          fonction-titre="Arbitrer (5x5 ou 3x3)"
          fonction-img="arbitrer.png"
          :is-fonction-disabled="isFonctionDisabled('A')"
          :is-fonction-checked="isFonctionChecked('A')"
          :active-fonction-list="activeFonctionList"
          @onUpdateFonctionList="updateActiveFonctionList"
        ></je-souhaite-fonction>
        <je-souhaite-fonction
          v-if="activeOffre != 'M'"
          fonction-id="E"
          fonction-titre="Entraîner une équipe"
          fonction-img="entraineur.png"
          :is-fonction-disabled="isFonctionDisabled('E')"
          :is-fonction-checked="isFonctionChecked('E')"
          :active-fonction-list="activeFonctionList"
          @onUpdateFonctionList="updateActiveFonctionList"
        ></je-souhaite-fonction>
        <je-souhaite-fonction
          v-if="activeOffre != 'M'"
          fonction-id="O"
          fonction-titre="Officier (hors arbitrage)"
          fonction-img="officiel.png"
          :is-fonction-disabled="isFonctionDisabled('O')"
          :is-fonction-checked="isFonctionChecked('O')"
          :active-fonction-list="activeFonctionList"
          @onUpdateFonctionList="updateActiveFonctionList"
        ></je-souhaite-fonction>
        <je-souhaite-fonction
          v-if="activeOffre != 'M'"
          fonction-id="D"
          fonction-titre="Diriger"
          fonction-img="dirigeant.png"
          :is-fonction-disabled="isFonctionDisabled('D')"
          :is-fonction-checked="isFonctionChecked('D')"
          :active-fonction-list="activeFonctionList"
          @onUpdateFonctionList="updateActiveFonctionList"
        ></je-souhaite-fonction>
        <je-souhaite-fonction
          v-if="activeOffre === 'NONE'"
          fonction-id="ADHERENT"
          fonction-titre="Adhérer (sans pratique ni fonction)"
          fonction-img="ffbb_black.png"
          :is-fonction-disabled="isFonctionDisabled('ADHERENT')"
          :is-fonction-checked="isFonctionChecked('ADHERENT')"
          :active-fonction-list="activeFonctionList"
          @onUpdateFonctionList="updateActiveFonctionList"
        ></je-souhaite-fonction>
      </div>

      <p
        v-if="activeOffre != '' && activeOffre != 'M'"
        class="je-souhaite-text-info mb-0"
        style="color: #dc3545;"
      >
        {{ "jeSouhaite_text_info_1" | translate(locale) }}
        <br />
        {{ "jeSouhaite_text_info_2" | translate(locale) }}
      </p>

      <div
        v-if="submitted && erreurJeSouhaite != ''"
        class="alert alert-danger text-left global-errors mt-5"
      >
        <p>
          {{ erreurJeSouhaite }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import JeSouhaiteOffre from "@/components/general/JeSouhaiteOffre.vue";
import JeSouhaiteFonction from "@/components/general/JeSouhaiteFonction.vue";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import translations from "@/Translations.js";
import _ from "lodash";

export default {
  components: {
    JeSouhaiteOffre,
    JeSouhaiteFonction
  },

  data() {
    return {
      preinscription_out: Object,
      activeOffre: "",
      submitted: false,
      erreurJeSouhaite: "",
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      activeFonctionList: [],
      listeTypesPratique: undefined,
      listeOffreC: ["5x5", "3x3", "MIN", "entreprise", "loisir", "vxe"],
      listeOffreL: ["5x5", "3x3"],
      listeOffreE: ["5x5", "3x3"],
      listeOffreVS: ["BS"],
      listeOffreVT: ["BT"],
      listeOffreVI: ["BI"],
      listeOffreM: ["MB"],
      isUpdateActiveOffre: false,
      token_out: undefined
    };
  },

  props: {
    preinscription: Object,
    token: undefined,
    locale: {
      type: String,
      default: "fr"
    }
  },

  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },

  methods: {
    canContinue() {
      this.submitted = true;
      this.validationPage(true);
    },
    validationPage(submit) {
      this.erreurJeSouhaite = "";
      if (this.activeOffre === "") {
        this.erreurJeSouhaite = "Vous devez sélectionner une pratique";
        this.$emit("can-continue", { value: false });
      } else if (
        // dans la liste activeFonctionList on peut avoir aussi les types pratique auxiliaire
        // 'NO_FONCTION' et 'ADHERENT' qui sont utilisés juste pour la validation coté client
        !_.some(this.activeFonctionList, function(fonction) {
          return (
            fonction != "J" &&
            fonction != "VS" &&
            fonction != "VT" &&
            fonction != "VI" &&
            fonction != "M"
          );
        })
      ) {
        this.erreurJeSouhaite = "Vous devez sélectionner au moins une fonction";
        this.$emit("can-continue", { value: false });
      } else if (
        // La photo est obligatoire sauf si vous souhaitez être dirigeant ou simple adhérent
        (this.preinscription_out.data.document.documentPhoto.id === null ||
          this.preinscription_out.data.document.documentPhoto.data === null) &&
        _.some(this.activeFonctionList, function(fonction) {
          return fonction != "D" && fonction != "U" && fonction != "ADHERENT";
        })
      ) {
        this.erreurJeSouhaite =
          "La photo est obligatoire, veuillez retourner à l'étape 'Je suis'";
        this.$emit("can-continue", { value: false });
      } else {
        // a la validation de la page, on doit retirer les types pratique 'NO_FONCTION' et 'ADHERENT'
        // qui sont des types auxiliaires (juste pour la validation coté client)
        if (submit) {
          _.remove(this.preinscription_out.data.typesPratique, function(type) {
            return type === "NO_FONCTION" || type === "ADHERENT";
          });
        }
        this.$emit("can-continue", {
          value: true,
          preinscription: this.preinscription_out
        });
      }
    },
    updateActiveOffre(offre) {
      this.activeOffre = offre;

      if (offre === "C") {
        this.preinscription_out.data.pratiqueSportive = offre;
        this.updateActiveFonctionList(offre, "J");
      } else if (offre === "L") {
        this.preinscription_out.data.pratiqueSportive = offre;
        this.updateActiveFonctionList(offre, "J");
      } else if (offre === "ETS") {
        this.preinscription_out.data.pratiqueSportive = "E";
        this.updateActiveFonctionList(offre, "J");
      } else if (offre === "VS") {
        this.preinscription_out.data.pratiqueSportive = null;
        this.updateActiveFonctionList(offre, "VS");
      } else if (offre === "VT") {
        this.preinscription_out.data.pratiqueSportive = null;
        this.updateActiveFonctionList(offre, "VT");
      } else if (offre === "VI") {
        this.preinscription_out.data.pratiqueSportive = null;
        this.updateActiveFonctionList(offre, "VI");
      } else if (offre === "M") {
        this.preinscription_out.data.pratiqueSportive = null;
        this.updateActiveFonctionList(offre, "M");
        // cocher automatiquement la fonction 'Ne souhaite pas exercer de fonction'
        // car il n'y a qu'un seul choix possible
        this.updateActiveFonctionList("", "NO_FONCTION");
      } else if (offre === "NONE") {
        this.preinscription_out.data.pratiqueSportive = null;
        this.updateActiveFonctionList(offre, "");
      }

      this.isUpdateActiveOffre = true;
    },
    updateActiveFonctionList(offre, fonction) {
      if (offre != "") {
        this.activeFonctionList = [];
        if (fonction != "") {
          this.activeFonctionList.push(fonction);
        }
        this.preinscription_out.data.typesPratique = this.activeFonctionList;
        return;
      }

      // "Ne souhaite pas exercer de fonction"
      // le type pratique 'NO_FONCTION' retire de la liste les autres types séléctionnés, sauf 'J', 'VS', 'VT', 'VI' ou 'M'
      if (fonction === "NO_FONCTION") {
        if (!this.activeFonctionList.includes(fonction)) {
          this.initialiserFonctionList();
          this.activeFonctionList.push(fonction);
        } else {
          this.initialiserFonctionList();
        }
        this.preinscription_out.data.typesPratique = this.activeFonctionList;
        return;
      }

      // "Etre simple adhérent"
      if (fonction === "ADHERENT") {
        if (!this.activeFonctionList.includes("U")) {
          this.activeFonctionList = [];
          this.activeFonctionList.push("U");
        } else {
          this.activeFonctionList = [];
        }

        this.preinscription_out.data.typesPratique = this.activeFonctionList;
        return;
      }

      // dans activeFonctionList on garde les fonctions selectionnees
      if (this.activeFonctionList.includes(fonction)) {
        this.activeFonctionList = this.activeFonctionList.filter(function(
          value
        ) {
          return value != fonction;
        });
      } else {
        this.activeFonctionList.push(fonction);
      }
      this.preinscription_out.data.typesPratique = this.activeFonctionList;
    },
    initialiserFonctionList() {
      // le type pratique 'NO_FONCTION' retire de la liste les autres types séléctionnés, sauf 'J', 'VS', 'VT', 'VI' ou 'M'
      this.activeFonctionList = [];
      if (
        this.activeOffre === "C" ||
        this.activeOffre === "L" ||
        this.activeOffre === "ETS"
      ) {
        this.activeFonctionList.push("J");
      } else if (this.activeOffre === "VS") {
        this.activeFonctionList.push("VS");
      } else if (this.activeOffre === "VT") {
        this.activeFonctionList.push("VT");
      } else if (this.activeOffre === "VI") {
        this.activeFonctionList.push("VI");
      } else if (this.activeOffre === "M") {
        this.activeFonctionList.push("M");
      }
    },
    isFonctionDisabled(fonctionId) {
      if (fonctionId === "ADHERENT" || fonctionId === "NO_FONCTION") {
        return false;
      }
      return (
        this.activeFonctionList.includes("ADHERENT") ||
        this.activeFonctionList.includes("U") ||
        this.activeFonctionList.includes("NO_FONCTION")
      );
    },
    isFonctionChecked(fonctionId) {
      return (
        this.activeFonctionList.includes(fonctionId) ||
        (fonctionId === "ADHERENT" && this.activeFonctionList.includes("U"))
      );
    },
    getOffresPratique(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getOffresPratique(this.token_out)
        .then(result => {
          // les types pratique a afficher
          that.listeTypesPratique = _.uniq(_.map(result.data, "typePratique"));
          // si on a des offres pour le typePratique "V", il faut les remplacer par "VS", "VT" ou "VI"
          if (that.listeTypesPratique.includes("V")) {
            _.remove(that.listeTypesPratique, function(type) {
              return type === "V";
            });
            var categories = _.uniq(_.map(result.data, "categoriePratique"));
            if (categories.includes("BS")) {
              that.listeTypesPratique.push("VS");
            }
            if (categories.includes("BT")) {
              that.listeTypesPratique.push("VT");
            }
            if (categories.includes("BI")) {
              that.listeTypesPratique.push("VI");
            }
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getOffresPratique,
            argsArray
          );
        });
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    },
    activeOffre: {
      handler: function() {
        this.validationPage(false);
      },
      immediate: true
    },
    activeFonctionList: {
      handler: function() {
        this.validationPage(false);
      },
      immediate: true
    }
  },
  created() {
    // la clone preinscription_out est utilisé dans le template et il faut l'initialiser avant mounted
    this.preinscription_out = JSON.parse(JSON.stringify(this.preinscription));

    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    this.getOffresPratique(false /*isReconnected*/);

    // valorises activeOffre et activeFonctionList quand on arrive sur la page
    this.activeFonctionList = JSON.parse(
      JSON.stringify(this.preinscription_out.data.typesPratique)
    );

    if (this.preinscription_out.data.pratiqueSportive != null) {
      if (this.preinscription_out.data.pratiqueSportive === "E") {
        this.activeOffre = "ETS";
      } else {
        this.activeOffre = this.preinscription_out.data.pratiqueSportive;
      }
    } else if (this.preinscription_out.data.typesPratique.includes("VS")) {
      this.activeOffre = "VS";
    } else if (this.preinscription_out.data.typesPratique.includes("VT")) {
      this.activeOffre = "VT";
    } else if (this.preinscription_out.data.typesPratique.includes("VI")) {
      this.activeOffre = "VI";
    } else if (this.preinscription_out.data.typesPratique.includes("M")) {
      this.activeOffre = "M";
    } else if (this.activeFonctionList.length != 0) {
      this.activeOffre = "NONE";
    }

    if (
      this.activeFonctionList.length === 1 &&
      (this.activeFonctionList.includes("J") ||
        this.activeFonctionList.includes("VS") ||
        this.activeFonctionList.includes("VT") ||
        this.activeFonctionList.includes("VI") ||
        this.activeFonctionList.includes("M"))
    ) {
      this.activeFonctionList.push("NO_FONCTION");
    } else if (
      this.activeFonctionList.length === 1 &&
      this.activeFonctionList.includes("U")
    ) {
      this.activeFonctionList.push("ADHERENT");
    }

    this.$emit("can-continue", { value: false });
  },
  updated() {
    if (
      this.isUpdateActiveOffre &&
      document.getElementById("partie-fonctions") !== null
    ) {
      document
        .getElementById("partie-fonctions")
        .scrollIntoView({ behavior: "smooth" });
      this.isUpdateActiveOffre = false;
    }
  }
};
</script>

<style>
.je-souhaite-text {
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 30px;
}

.je-souhaite-text-info {
  text-align: center;
  font-family: Lato;
  font-size: 9px;
  line-height: 17px;
  color: #000000;
  white-space: pre-line;
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .jeSouhaitePage {
    margin: 3rem 8rem;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .jeSouhaitePage {
    margin: 10px 15px;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .jeSouhaitePage {
    margin: 3rem 3rem;
  }
}
</style>
